import { client } from '@/common-utils/libraries/axios/axios';
import CONTRACT_ACCESS from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationCreateMerchantUser = (onSuccess, onError) => {
    return {
        mutationFn: ({ usersList, merchantAccountId }) => {
            return client.post(replaceParameters(CONTRACT_ACCESS.DETAILS.url, { contractAccessId: merchantAccountId }), usersList);
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationCreateMerchantUser;